// import { gatewayClient } from 'boot/axios'
import businessClient from 'src/services/clients/business'
import {
  IMeta,
  // IServerNames,
  ISubsidiaryLedger,
  ITransactions,
} from 'src/common/interfaces/index.js'

const ISubsidiaryLedgerResponse = { meta: IMeta, data: { list: [ISubsidiaryLedger] } }
const ITransactionsResponse = { meta: IMeta, data: { list: [ITransactions] } }

// FIXME: DeepSource does not identify the interfaces as 'used' variables. Therefore, it suggests to remove the interface imports. However, the interfaces are being used in JSDoc format for each service.
export const accounting = {
  /**
   * @param {{store_id: number, account_type: number}} filter
   * @return {ISubsidiaryLedgerResponse}
   */
  subsidiaryList(filter, signal) {
    return businessClient().post('accounting/charts/portal/subsidiary-ledger-list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number, subsidiary_ledger: number, page: number, row_number: number}} filter
   * @return {ISubsidiaryLedgerResponse}
   */
  subLedgersList(filter, signal) {
    return businessClient().post('accounting/charts/portal/sub-ledger-list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number, subsidiary_ledger: number, page: number, subledger: number}} filter
   * @return {ISubsidiaryLedgerResponse}
   */
  transactionsList(filter, signal) {
    return businessClient().post('accounting/transactions/portal/list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number, subsidiary_ledger: number, account_name: string, account_type: number}} data
   * @return {ISubsidiaryLedgerResponse}
   */
  subsidiaryLedgerUpsert(data) {
    return businessClient().post('accounting/charts/upsert/subsidiary-ledger', { data }, { signal })
  },

  /**
   * @param {{store_id: number, subsidiary_ledger: number, account_name: string, subledger: number, currency_code: string }} data
   * @return {ITransactionsResponse}
   */
  subledgerUpsert(data) {
    return businessClient().post('accounting/charts/upsert/subledger', { data }, { signal })
  },
}
